import { LABEL_STATUS_EXCLUDED, LABEL_STATUS_INCLUDED, LABEL_STATUS_NONE, getNextLabelStatus } from '../components/privatearea/game/gamelabel/GameLabelStatus';

export const toggleLabel = (labelId, checkedLabels) => {
    const newCheckedLabels = new Map(checkedLabels);
    const curStatus = newCheckedLabels.has(labelId) ? newCheckedLabels.get(labelId) : 0;
    const nextStatus = getNextLabelStatus(curStatus);
    if (nextStatus === LABEL_STATUS_NONE) {
        newCheckedLabels.delete(labelId);
    } else {
        newCheckedLabels.set(labelId, nextStatus);
    }
    return newCheckedLabels;
};

export const getLabelFilter = (checkedLabels) => ({
    includedGameLabelIds: Array.from(checkedLabels.entries()).filter(([, v]) => v === LABEL_STATUS_INCLUDED).map(([k]) => k),
    excludedGameLabelIds: Array.from(checkedLabels.entries()).filter(([, v]) => v === LABEL_STATUS_EXCLUDED).map(([k]) => k),
});
